module.exports = __webpack_public_path__ + "static/img/2_2_1_1.cccbc5c6.jpg";